export const GridConfig = (function () {
    const instance = {};
    class GridConfig {
        cellWidth = 100;

        cellHeight = 100;

        gridWidth = 1000;

        gridHeight = 1200;

        viewPadding = 500;

        line_width = 1;

        initialViewPadding = 100;

        noPaddingWidth;

        noPaddingHeight;

        instanceUuid;

        constructor(diagramInstanceUuid) {
            if (!instance[diagramInstanceUuid]) {
                // setting the singleton instance
                instance[diagramInstanceUuid] = this;
                this.instanceUuid = diagramInstanceUuid;
            }
            return instance[diagramInstanceUuid];
        }

        /**
         * @description resets the grid config values to default
         */
        resetValuesToDefault() {
            this.cellWidth = 100;
            this.cellHeight = 100;
            this.gridWidth = 1000;
            this.gridHeight = 1200;
            this.viewPadding = 500;
            this.line_width = 1;
            this.initialViewPadding = 100;
            this.noPaddingWidth = null;
            this.noPaddingHeight = null;
        }

        /**
         * @description destroys the gridconfig instance
         * @param {*} instanceUuid
         */
        destroy(instanceUuid) {
            instance[instanceUuid] = null;
            delete instance[instanceUuid];
        }

        /**
         * @description Calculates the initial camera position at load time
         */
        getInitialCameraPosition(ctx, grid) {
            const { canvas } = ctx;
            const { width } = canvas;
            const gridWidth = grid[0].length * this.cellWidth;
            let x = null;
            if (gridWidth + this.cellWidth >= width) {
                x = this.viewPadding - this.initialViewPadding;
            } else {
                x = this.viewPadding - (width - gridWidth) / 2;
            }
            return {
                left: x,
                top: this.viewPadding - this.initialViewPadding
            };
        }

        /**
         * @description calculates the view size
         * @param {*} data
         */
        calculateViewSize(data) {
            let gridViewSize;
            if (!data || (data && !data.gridView)) {
                gridViewSize = {};
                gridViewSize.width = this.gridWidth;
                gridViewSize.height = this.gridHeight;
            } else {
                gridViewSize = data.gridView;
                gridViewSize.width = gridViewSize.cols * gridViewSize.cellWidth;
                gridViewSize.height = gridViewSize.rows * gridViewSize.cellHeight;
            }
            gridViewSize.gridWidth = gridViewSize.width;
            gridViewSize.gridHeight = gridViewSize.height;
            gridViewSize.viewPadding = this.viewPadding;
            gridViewSize.initialViewPadding = this.initialViewPadding;
            gridViewSize.cellWidth = this.cellWidth;
            gridViewSize.cellHeight = this.cellHeight;
            gridViewSize.lineWidth = this.line_width;
            this.noPaddingWidth = gridViewSize.noPaddingWidth = gridViewSize.width;
            this.noPaddingHeight = gridViewSize.noPaddingHeight = gridViewSize.height;
            this.gridWidth = gridViewSize.width += (this.viewPadding * 2);
            this.gridHeight = gridViewSize.height += (this.viewPadding * 2);
            return gridViewSize;
        }

        /**
         * @description returns a object with grid config options
         */
        getGridCellCreationOptions() {
            return {
                gridWidth: this.noPaddingWidth,
                gridHeight: this.noPaddingHeight,
                // padding around grid
                viewPadding: this.viewPadding,
                initialViewPadding: this.initialViewPadding,
                // cell width
                cellWidth: this.cellWidth,
                cellHeight: this.cellHeight,
                lineWidth: this.line_width
            };
        }
    }
    return GridConfig;
}());
